"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const StatesInTerritory_1 = __importDefault(require("./StatesInTerritory"));
exports.default = StatesInTerritory_1.default;
